module.exports = __webpack_public_path__ + "01_hair_silver.6fb3c2a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/01_hair_silver.png
// module id = 3ur7
// module chunks = 0